import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { BRANDS } from '../config'
import TopMenu from './TopMenu'
import UnifiedHeader from './UnifiedHeader'
import FeedbackModal from './FeedbackModal'
import { isOffline, onConnectivityChange } from '../services/offlineDetect'
import {
  navigateUnifiedHeaderLogo,
  buildSelectModelMenuLink,
  buildBrowseGuideMobileActionsTray,
} from '../extras/unifiedHeaderNavigation'

class BrowseGuideHeader extends Component {
  static propTypes = {
    currentBrand: PropTypes.object,
    currentModel: PropTypes.string,
    currentYear: PropTypes.string,
    brandRoute: PropTypes.string.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    userMedia: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }),
  }

  state = {
    offline: isOffline(),
    isFeedbackModalOpen: false,
  }

  componentDidMount() {
    this.unsubscribeConnectivity = onConnectivityChange(online => {
      this.setState({ offline: !online })
    })
  }

  componentWillUnmount() {
    if (this.unsubscribeConnectivity) {
      this.unsubscribeConnectivity()
    }
  }

  buildTopMenuLinks() {
    const { userMedia } = this.props
    const { offline } = this.state

    return [
      buildSelectModelMenuLink({
        userMedia,
        offline,
      }),
    ]
  }

  handleLogoClick = () => {
    navigateUnifiedHeaderLogo(this.props.history, this.state.offline)
  }

  handleFeedbackClick = () => {
    this.setState({ isFeedbackModalOpen: true })
  }

  render() {
    const { currentBrand, currentModel, currentYear, userMedia } = this.props
    const { offline, isFeedbackModalOpen } = this.state
    const brandName = currentBrand?.title || currentBrand?.name || ''
    const topMenuLinks = this.buildTopMenuLinks()
    const mobileActionsTray = buildBrowseGuideMobileActionsTray({
      userMedia,
      offline,
      onFeedbackClick: this.handleFeedbackClick,
    })

    return (
      <>
        {isFeedbackModalOpen && (
          <FeedbackModal
            onClose={() => {
              this.setState({ isFeedbackModalOpen: false })
            }}
            currentBrand={brandName}
            currentModel={currentModel}
            currentYear={currentYear}
          />
        )}
        <UnifiedHeader
          onLogoClick={this.handleLogoClick}
          breadcrumb={
            <div className="UnifiedHeader-vehicleTitle">
              <em>
                {currentYear} {brandName}
              </em>
              <span>{currentModel}</span>
            </div>
          }
          mobileDropdown={mobileActionsTray}
          actions={
            userMedia?.isDesktop ? (
              <TopMenu
                links={topMenuLinks}
                currentBrand={brandName}
                currentModel={currentModel}
                currentYear={currentYear}
                offline={offline}
              />
            ) : null
          }
        />
      </>
    )
  }
}

function mapStateToProps({ user, vehicle: { currentBrand, currentModel, currentYear } }) {
  const brand = BRANDS.find(item => item.name === currentBrand)

  return {
    userMedia: user.media,
    currentBrand: brand,
    currentModel,
    currentYear,
    brandRoute: brand ? `/${brand.key}` : '/',
  }
}

export default withRouter(connect(mapStateToProps)(BrowseGuideHeader))
